const stats = [
  {
    value: "300",
    suffix: "+",
    title: "已服务市场商户",
    desc: "覆盖义乌、广州、深圳、佛山等试点市场",
    icon: "ri-store-3-line",
    grad: "from-primary-500 to-primary-600",
  },
  {
    value: "10",
    suffix: "亿+",
    title: "累计出口货值",
    desc: "每一单都阳光合规、可追溯、可审计",
    icon: "ri-exchange-funds-line",
    grad: "from-accent-500 to-accent-400",
  },
  {
    value: "2",
    suffix: "天",
    title: "平均通关时效",
    desc: "简化申报，小批量也能快速通关出海",
    icon: "ri-rocket-line",
    grad: "from-primary-500 to-primary-600",
  },
];

export default function Stats() {
  return (
    <section className="py-16 md:py-24 bg-gradient-to-b from-background-100 to-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-flex items-center gap-1.5 bg-background-50 border border-primary-200 text-primary-700 text-sm font-medium px-4 py-1.5 rounded-full mb-5">
            真实数据，持续更新
          </span>
          <h2 className="text-[28px] md:text-[38px] font-heading font-extrabold text-foreground-950 mb-4 tracking-tight">
            已服务 <span className="text-primary-600">300+ </span>家市场商户
          </h2>
          <p className="text-foreground-500 text-[15px] md:text-[17px] max-w-xl mx-auto">
            从个体小商户到外贸公司，全电易帮他们把市场采购贸易
            从"没法出口"变成"标准动作"
          </p>
        </div>

        <div className="grid sm:grid-cols-3 gap-4 md:gap-6">
          {stats.map((s, i) => (
            <div
              key={i}
              className="bg-background-50 border border-background-200 rounded-2xl p-6 md:p-8 shadow-[0_4px_20px_-4px_rgba(0,0,0,0.04)] hover:-translate-y-1 transition-all duration-300"
            >
              <div
                className={`w-14 h-14 rounded-xl bg-gradient-to-br flex items-center justify-center mb-6 ${s.grad}`}
              >
                <i className={`text-background-50 text-2xl ${s.icon}`} />
              </div>
              <div className="flex items-baseline gap-1 mb-3">
                <span className="text-[40px] md:text-[52px] font-heading font-extrabold text-foreground-900 leading-none tabular-nums tracking-tight">
                  {s.value}
                </span>
                <span className="text-2xl font-bold text-foreground-500">
                  {s.suffix}
                </span>
              </div>
              <div className="text-[15px] md:text-[17px] font-bold text-foreground-800 mb-2">
                {s.title}
              </div>
              <div className="text-[13px] md:text-[14px] text-foreground-400 leading-relaxed">
                {s.desc}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}